import moment from "moment-timezone";

export const convertUtcToIst = (istDate) => {
  const utcDate = moment
    .tz(istDate, "Asia/Kolkata") 
    .utc()
    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"); 
  
  return utcDate;
};